import React from 'react';
import { Root, ProgressBar, Bar } from './styles';
import { cx } from '@linaria/core';
function Progress({ type, progress }) {
    /** JSX */
    return (React.createElement("div", { className: cx(Root.base) },
        React.createElement("div", { className: cx(ProgressBar.base) },
            React.createElement("span", { className: cx(Bar.base, Bar.type[type]), style: { width: `${progress}%` } }))));
}
export default Progress;
